import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import { useAuth } from "../AuthContext";
import axios from "axios";
import iziToast from "izitoast";
import Footer from "./Footer";

export const AddStudent = () => {

    const { apipath, logout, goBack } = useAuth();
    const navigate = useNavigate();
    const token = localStorage.getItem('token');
    const userType = localStorage.getItem('userType');
    const [isLoading, setIsLoading] = useState(false);
    const [activeTab, setActiveTab] = useState("Student");
    const [organizations, setOrganizations] = useState([]);
    const [exams, setExams] = useState([]);
    const [tests, setTests] = useState([]);

    const [formData, setFormData] = useState({
        organization: "",
        exam: "",
        test: "",
        name: "",
        fname: "",
        roll_no: "",
        email: "",
        phone: "",
        state: "",
        city: "",
        pincode: "",
        address: "",
        photo: null,
    });

    useEffect(() => {
        const getOrganizations = async () => {
            try {
                const response = await axios.post(
                    apipath + '/organizations',
                    {},
                    {
                        headers: {
                            Authorization: 'Bearer ' + token
                        }
                    }
                );
                // console.log(response.data);
                if (response.data.status === "unauthentic") {
                    iziToast.error({
                        'message': response.data.message,
                        'position': 'topCenter'
                    });
                    logout();
                }
                if (response.data.status === "false") {
                    iziToast.error({
                        'message': response.data.message,
                        'position': 'topCenter'
                    });
                    return false;
                }
                setOrganizations(response.data.organizations);
            }
            catch (error) {
                // console.error('Error fetching data:', error);
                if (error.status === 401) {
                    iziToast.error({
                        message: "Un-Authorised! Please Login.",
                        position: "topCenter"
                    });
                    logout();
                }
                else{
                    iziToast.error({
                        message: error,
                        position: 'topCenter'
                    });
                }

            } finally {

            }
        }
        getOrganizations();
    }, []);

    
    const getExams = async () => {
        try {
            const response = await axios.post(
                apipath + '/exams',
                { 'id': formData.organization },
                {
                    headers: {
                        Authorization: 'Bearer ' + token
                    }
                }
            );
            // console.log(response.data);
            if (response.data.status === "unauthentic") {
                iziToast.error({
                    message: response.data.message,
                    position: "topCenter"
                });
                logout();
            }
            if (response.data.status === "false") {
                iziToast.error({
                    message: response.data.message,
                    position: "topCenter"
                });
                return false;
            }
            setExams(response.data.exams);
        }
        catch (error) {
            // console.error('Error fetching data:', error);
            if (error.status === 401) {
                iziToast.error({
                    message: "Un-Authorised! Please Login.",
                    position: "topCenter"
                });
                logout();
            }
            else {
                iziToast.error({
                    message: error,
                    position: 'topCenter'
                });
            }

        } finally {

        }
    }
    useEffect(() => {
        getExams();
    }, [formData.organization]);

    
    const getTests = async () => {
        try {
            if(formData.exam){
                const response = await axios.post(
                    apipath + '/test_schedules',
                    { 'exam_id': formData.exam },
                    {
                        headers: {
                            Authorization: 'Bearer ' + token
                        }
                    }
                );
                // console.log(response.data);
                if (response.data.status === "unauthentic") {
                    iziToast.error({
                        message: response.data.message,
                        position: "topCenter"
                    });
                    logout();
                }
                if (response.data.status === "false") {
                    iziToast.error({
                        message: response.data.message,
                        position: "topCenter"
                    });
                    return false;
                }
                setTests(response.data.tests);
            }
            else{
                setTests([]);
            }
        }
        catch (error) {
            // console.error('Error fetching data:', error);
            if (error.status === 401) {
                iziToast.error({
                    message: "Un-Authorised! Please Login.",
                    position: "topCenter"
                });
                logout();
            }
            else {
                iziToast.error({
                    message: error,
                    position: 'topCenter'
                });
            }

        } finally {

        }
    }
    useEffect(() => {
        getTests();
    }, [formData.exam]);

    const [errors, setErrors] = useState({});
    const [showPassword, setShowPassword] = useState(false);
    
    const handleOrganizationChange = (e) => {
        setFormData({
            ...formData,
            organization: e.target.value,
            exam: "",  // Reset exam when organization changes
            test: "",
        });
    };
    const handleExamChange = (e) => {
        setFormData({
            ...formData,
            exam: e.target.value,
            test: "",
        });
    };

    const handleFileChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.files[0] });
    };
    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
    };

    // const togglePasswordVisibility = () => {
    //     setShowPassword(!showPassword);
    // };

    const validate = () => {
        let tempErrors = {};
        if (!formData.organization) tempErrors.organization = "Organization is required";
        if (!formData.exam) tempErrors.exam = "Exam is required";
        if (!formData.test) tempErrors.test = "Test is required";
        if (!formData.name) tempErrors.name = "Name is required";
        if (!formData.fname) tempErrors.fname = "Father's Name is required";
        // if (!formData.roll_no) tempErrors.roll_no = "Roll Number is required";
        // if (!/^\d+$/.test(formData.roll_no))
        //     tempErrors.roll_no = "Roll Number must be numeric";
        if (!formData.email) tempErrors.email = "Email is required";
        if (!/\S+@\S+\.\S+/.test(formData.email))
            tempErrors.email = "Email is invalid";
        if (!formData.phone) tempErrors.phone = "Phone is required";
        if (!/^\d{10}$/.test(formData.phone))
            tempErrors.phone = "Phone number must be 10 digits";
        if (!formData.state) tempErrors.state = "State is required";
        if (!formData.city) tempErrors.city = "City is required";
        if (!formData.pincode) tempErrors.pincode = "Pincode is required";
        if (!/^\d{6}$/.test(formData.pincode))
            tempErrors.pincode = "Pincode must be 6 digits";
        if (!formData.address) tempErrors.address = "Address is required";

        setErrors(tempErrors);

        return Object.keys(tempErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (validate()) {
            setIsLoading(true);
            // console.log(formData);
            try {
                const response = await axios.post(
                    apipath + '/add_student', formData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                            Authorization: 'Bearer ' + token
                        }
                    }
                );
                console.log(response.data);
                if (response.data.status === "unauthentic") {
                    iziToast.error({
                        'message': response.data.message,
                        'position': 'topCenter'
                    });
                    logout();
                }
                if (response.data.status === "false") {
                    iziToast.error({
                        message: response.data.message,
                        position: "topCenter"
                    });
                    return false;
                }
                else {
                    iziToast.success({
                        message: response.data.message,
                        position: "topCenter"
                    });
                    navigate('/students');
                }
            }
            catch (error) {
                console.error('Error fetching data:', error);
                if (error.status === 401) {
                    iziToast.error({
                        message: "Un-Authorised! Please Login.",
                        position: "topCenter"
                    });
                    logout();
                }
                else{
                    iziToast.error({
                        message: error,
                        position: 'topCenter'
                    });
                }
            }
            finally{
                setIsLoading(false);
            }
            // Process the form data here (e.g., send it to the server)
        }
    };


    return (
        <>
            <span className={(isLoading) ? "flex items-center text-white bg-gray-400/75 justify-center fixed top-0 left-0 w-full h-screen z-50" : "hidden"}>
                <svg
                    className="w-5 h-5 mr-2 animate-spin"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                >
                    <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                    ></circle>
                    <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8v4l3-3-3-3V4a10 10 0 1010 10h-4l3 3 3-3h-4a8 8 0 01-8 8z"
                    ></path>
                </svg>
                Loading...
            </span>
            {<Navbar />}
            <div class="flex flex-col md:flex-row">
                {<Sidebar activePage={"students"} />}
                <div class="main-content flex-1 bg-gray-100 pb-24 md:pb-5 w-full md:w-4/5 lg:w-5/6 pt-16 md:pt-8">

                    <div class="bg-teal-700 pt-4">
                        <div class="rounded-tl-3xl bg-teal-600 p-2 justify-between shadow text-2xl text-white flex flex-col md:flex-row relative">
                            <span class="font-bold pl-2">
                            <i className="fa fa-arrow-left text-sm border-2 rounded absolute right-3 py-1 px-2 top-2 bg-teal-700 hover:bg-teal-800 cursor-pointer" title="go back" onClick={()=>goBack()}></i>Add Student</span>
                            {/* <div className="flex flex-row mt-4 md:mt-0">
                                {(userType !== 'admin') ? <>
                                    <Link to={`/users`}><span class={`md:ml-5 ml-2 ${activeTab === 'Organization' ? 'bg-teal-800 border-transparent' : 'bg-transparent border-white'} hover:bg-teal-900 text-white font-medium text-base py-1 px-4 border hover:border-transparent rounded`}>
                                        Organizations
                                    </span></Link>
                                    <Link to={`/students`}><span class={`md:ml-5 ml-2 ${activeTab === 'Student' ? 'bg-teal-800 border-transparent' : 'bg-transparent border-white'} hover:bg-teal-900 text-white font-medium text-base py-1 px-4 border hover:border-transparent rounded`}>
                                        Students
                                    </span></Link></> : <></>}
                            </div> */}
                        </div>
                        {/* <div class="bg-gradient-to-r from-cyan-900 to-cyan-900 px-4 py-2 shadow text-base text-white">
                            <h3 class="font-medium pl-2">Users</h3>
                        </div> */}
                    </div>

                    <div class="flex flex-wrap">
                        <div class="w-full p-2">
                            <form onSubmit={handleSubmit} className=" mx-auto px-4 py-2 space-y-6 bg-white rounded-lg shadow-lg">
                                <h2 className="text-2xl font-bold text-teal-800 text-center">Add Student</h2>
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-h-[60vh] overflow-auto">
                                    {/* Organization */}
                                    <div>
                                        <label className="block font-medium">Organization</label>
                                        <select
                                            name="organization"
                                            onChange={handleOrganizationChange}
                                            className="w-full border px-3 py-2 rounded focus:outline-none"
                                        >
                                            <option value={""}>Select Organization</option>
                                            {organizations.map((org) => {
                                                return (<>
                                                    <option value={org.id}>{org.name}</option>
                                                </>)
                                            })}
                                        </select>
                                        {errors.organization && <p className="text-red-500 text-sm">{errors.organization}</p>}
                                    </div>
                                    <div>
                                        <label className="block font-medium">Exam</label>
                                        <select
                                            name="exam"
                                            onChange={handleExamChange}
                                            className="w-full border px-3 py-2 rounded focus:outline-none"
                                        >
                                            <option value={""}>Select Exam</option>
                                            {exams.map((exm) => {
                                                return (<>
                                                    <option value={exm.id}>{exm.exam_name}</option>
                                                </>)
                                            })}
                                        </select>
                                        {errors.exam && <p className="text-red-500 text-sm">{errors.exam}</p>}
                                    </div>
                                    <div>
                                        <label className="block font-medium">Test</label>
                                        <select
                                            name="test"
                                            onChange={handleChange}
                                            className="w-full border px-3 py-2 rounded focus:outline-none"
                                        >
                                            <option value={""}>Select Test</option>
                                            {tests.map((tst) => {
                                                return (<>
                                                    <option value={tst.id}>{tst.test?.test_name + " ("+tst.start_time+")"}</option>
                                                </>)
                                            })}
                                        </select>
                                        {errors.test && <p className="text-red-500 text-sm">{errors.test}</p>}
                                    </div>

                                    <div>
                                        <label className="block font-medium">User Image</label>
                                        <input
                                            type="file"
                                            name="photo"
                                            onChange={handleFileChange}
                                            className="w-full border px-3 py-2 rounded focus:outline-none"
                                        />
                                    </div>
                                    {/* Name */}
                                    <div>
                                        <label className="block font-medium">Name</label>
                                        <input
                                            type="text"
                                            name="name"
                                            value={formData.name}
                                            onChange={handleChange}
                                            className="w-full border px-3 py-2 rounded focus:outline-none"
                                        />
                                        {errors.name && <p className="text-red-500 text-sm">{errors.name}</p>}
                                    </div>

                                    {/* Father's Name */}
                                    <div>
                                        <label className="block font-medium">Father's Name</label>
                                        <input
                                            type="text"
                                            name="fname"
                                            value={formData.fname}
                                            onChange={handleChange}
                                            className="w-full border px-3 py-2 rounded focus:outline-none"
                                        />
                                        {errors.fname && (
                                            <p className="text-red-500 text-sm">{errors.fname}</p>
                                        )}
                                    </div>

                                    {/* Roll Number */}
                                    <div>
                                        <label className="block font-medium">Roll Number</label>
                                        <input
                                            type="text"
                                            name="roll_no"
                                            value={formData.roll_no}
                                            onChange={handleChange}
                                            className="w-full border px-3 py-2 rounded focus:outline-none"
                                        />
                                        {errors.roll_no && (
                                            <p className="text-red-500 text-sm">{errors.roll_no}</p>
                                        )}
                                    </div>

                                    {/* Email */}
                                    <div>
                                        <label className="block font-medium">Email</label>
                                        <input
                                            type="email"
                                            name="email"
                                            value={formData.email}
                                            onChange={handleChange}
                                            className="w-full border px-3 py-2 rounded focus:outline-none"
                                        />
                                        {errors.email && (
                                            <p className="text-red-500 text-sm">{errors.email}</p>
                                        )}
                                    </div>

                                    {/* Phone */}
                                    <div>
                                        <label className="block font-medium">Phone</label>
                                        <input
                                            type="text"
                                            name="phone"
                                            value={formData.phone}
                                            onChange={handleChange}
                                            className="w-full border px-3 py-2 rounded focus:outline-none"
                                        />
                                        {errors.phone && (
                                            <p className="text-red-500 text-sm">{errors.phone}</p>
                                        )}
                                    </div>

                                    {/* State */}
                                    <div>
                                        <label className="block font-medium">State</label>
                                        <input
                                            type="text"
                                            name="state"
                                            value={formData.state}
                                            onChange={handleChange}
                                            className="w-full border px-3 py-2 rounded focus:outline-none"
                                        />
                                        {errors.state && (
                                            <p className="text-red-500 text-sm">{errors.state}</p>
                                        )}
                                    </div>

                                    {/* City */}
                                    <div>
                                        <label className="block font-medium">City</label>
                                        <input
                                            type="text"
                                            name="city"
                                            value={formData.city}
                                            onChange={handleChange}
                                            className="w-full border px-3 py-2 rounded focus:outline-none"
                                        />
                                        {errors.city && (
                                            <p className="text-red-500 text-sm">{errors.city}</p>
                                        )}
                                    </div>

                                    {/* Pincode */}
                                    <div>
                                        <label className="block font-medium">Pincode</label>
                                        <input
                                            type="text"
                                            name="pincode"
                                            value={formData.pincode}
                                            onChange={handleChange}
                                            className="w-full border px-3 py-2 rounded focus:outline-none"
                                        />
                                        {errors.pincode && (
                                            <p className="text-red-500 text-sm">{errors.pincode}</p>
                                        )}
                                    </div>

                                    {/* Address */}
                                    <div className="md:col-span-2">
                                        <label className="block font-medium">Address</label>
                                        <textarea
                                            name="address"
                                            value={formData.address}
                                            onChange={handleChange}
                                            className="w-full border px-3 py-2 rounded focus:outline-none"
                                        />
                                        {errors.address && (
                                            <p className="text-red-500 text-sm">{errors.address}</p>
                                        )}
                                    </div>

                                </div>

                                <div className="text-center">
                                    <button type="submit" className="bg-teal-500 text-white px-6 py-2 rounded-md hover:bg-teal-600">
                                        Create Student
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <Footer/>
        </>
    )
};